import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	Button,
	Icon,
} from '@uturn/ui-kit';
import { useMultiUpdateConfirmationContent } from './hooks/useMultiUpdateConfirmationContent';
import { UpdateFilters } from './multi-update-dialog';

type Props = {
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
	isSubmitting?: boolean;
	groupStatus: 'assigned' | 'unassigned';
	isImpactField: boolean;
	isQuoteImpactField: boolean;
	isUnpublish?: boolean;
	totalShipments: number;
	groupId: number;
	filters: UpdateFilters;
};

export const MultiUpdateConfirmationDialog = ({
	open,
	onCancel,
	onConfirm,
	isSubmitting,
	groupStatus,
	isImpactField,
	isQuoteImpactField,
	isUnpublish,
	totalShipments,
	groupId,
	filters,
}: Props) => {
	const { title, description, confirmLabel, cancelLabel } =
		useMultiUpdateConfirmationContent({
			groupStatus,
			isImpactField,
			isQuoteImpactField,
			isUnpublish,
			totalShipments,
			groupId,
			filters,
		});

	return (
		<AlertDialog open={open}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{title}</AlertDialogTitle>
					<AlertDialogDescription>{description}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel asChild>
						<Button variant="outline" onClick={onCancel}>
							{cancelLabel}
						</Button>
					</AlertDialogCancel>
					<Button onClick={onConfirm} className="min-w-[120px]">
						{isSubmitting && (
							<Icon className="mr-2 size-4" icon={faSpinnerThird} spin />
						)}
						{confirmLabel}
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
